import React, { useState} from "react";
import {useNavigate} from "react-router-dom";
// import DeletedClientsList from "./DeletedClients/DeletedClientsList";
import PowerBiList from "./PowerBiList";


const PowerBiTabs = () => {

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("powerbi-list");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        navigate(`../${tab}`);
    };



    return (
        <>
        
            <div className="tabs1">
                <div className="gms-table-tabs">
                    <button className={`tab-button tab-btn1 ${activeTab === "powerbi-list" ? "active" : ""}`}
                            onClick={() => handleTabChange("powerbi-list")}
                    >
                        Power BI List
                    </button>

                    {/* <button className={`tab-button tab-btn1 ${activeTab === "deleted-clients" ? "active" : ""}`}
                            onClick={() => handleTabChange("deleted-clients")}
                    >
                        Deleted Clients
                    </button> */}

                   
                </div>
            </div>

            <div className="tab-content">
                {activeTab === "powerbi-list" && <PowerBiList/>}
                {/* {activeTab === "deleted-clients" && <DeletedClientsList/>} */}
            </div>

        </>
    );
};

export default PowerBiTabs;
